const data = [
  {
    id: 1,
    name: 'Ao molho',
    description:
      'Macarrão ao molho branco, fughi e cheiro verde das montanhas.',
    price: '19.90',
    available: true,
    image:
      'https://storage.googleapis.com/golden-wind/bootcamp-gostack/desafio-food/food1.png',
  },
  {
    id: 2,
    name: 'Veggie',
    description:
      'Macarrão com pimentão, ervilha e ervas finas colhidas no himalaia.',
    price: '21.90',
    available: true,
    image:
      'https://storage.googleapis.com/golden-wind/bootcamp-gostack/desafio-food/food2.png',
  },
  {
    id: 3,
    name: 'A la Camarón',
    description:
      'Macarrão com vegetais de primeira linha e camarão dos 7 mares.',
    price: '25.90',
    available: true,
    image:
      'https://storage.googleapis.com/golden-wind/bootcamp-gostack/desafio-food/food3.png',
  },
  {
    image:
      'https://storage.googleapis.com/golden-wind/bootcamp-gostack/desafio-food/food1.png',
    name: 'Pizza',
    price: '20.90',
    description: 'Pizza Pequeno',
    id: 4,
    available: true,
  },
];

export default data;
